// =============================================================================
// Solmart Korean product names — cart page.
// =============================================================================
// The cart page is the parent theme's React app, fed by the WooCommerce Store
// API, so neither woocommerce_cart_item_name nor woocommerce_get_item_data reach
// it. inc/product-korean-name.php prints `window.solmartKoreanNames` (product
// name → Korean name) for the live cart instead, and this module adds the
// second line under each row's name.
//
// Rows are re-rendered whenever the cart changes, so the pass runs again on the
// parent's `ai-zippy-cart-updated` event and observes the list. Adding the span
// sits outside React's children, so React patches around it.
//
// The row's name is marked `notranslate` before the language switcher can reach
// it: otherwise GTranslate prints the name in Korean and our line repeats it.
// =============================================================================

/** Keep GTranslate off an element (class for Google, attribute for the widget). */
function notranslate(el) {
	el.classList.add("notranslate");
	el.setAttribute("translate", "no");
}

export default function initCartKoreanNames() {
	const map = window.solmartKoreanNames || {};

	if (Object.keys(map).length === 0) {
		return;
	}

	const decorate = () => {
		document.querySelectorAll(".zc-items__list .zc-row__info").forEach((info) => {
			const nameEl = info.querySelector(".zc-row__name");

			if (!nameEl) {
				return;
			}

			const korean = map[nameEl.textContent.trim()];

			if (!korean) {
				return;
			}

			const existing = info.querySelector(".sol-kr-name");

			notranslate(nameEl);

			if (existing) {
				notranslate(existing);

				if (existing.textContent !== korean) {
					existing.textContent = korean;
				}
				return;
			}

			const span = document.createElement("span");
			span.className = "sol-kr-name";
			span.textContent = korean;
			notranslate(span);
			nameEl.after(span);
		});
	};

	decorate();

	window.addEventListener("ai-zippy-cart-updated", decorate);

	const list = document.querySelector(".zc-items__list");

	if (list) {
		new MutationObserver(decorate).observe(list, { childList: true, subtree: true });
	}
}
